import { render, staticRenderFns } from "./StudentProfile.vue?vue&type=template&id=4a72bc66&scoped=true"
import script from "./StudentProfile.vue?vue&type=script&lang=js"
export * from "./StudentProfile.vue?vue&type=script&lang=js"
import style0 from "./StudentProfile.vue?vue&type=style&index=0&id=4a72bc66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a72bc66",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
